import { DEFAULT_ENTITY, LOADER_STATUS, PROFILE_DATA, SET_ENTITY_LIST, STORE_GSTIN_IMS, STORE_PERIOD_SINGLE, SET_IMS_FETCH_HISTORY } from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  selectedPeriodSingle: null,
  selectedGstin: [],
  defaultEntity: "",
  profileData: [],
  entityMasterList: [],
};
/* eslint-disable default-case, no-param-reassign */
const imsCommonReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
      
    case STORE_PERIOD_SINGLE:
      return {
        ...state,
        selectedPeriodSingle: action.date,
      };
      case STORE_GSTIN_IMS:
        return {
          ...state,
          selectedGstin: action.selectedGstin,
        };
        case DEFAULT_ENTITY:
      return {
        ...state,
        defaultEntity: action.data,
      };
      case PROFILE_DATA:
        return {
          ...state,
          profileData: action.profileData,
        };
        case SET_ENTITY_LIST:
          return {
            ...state,
            entityMasterList: action.payload,
          };
    default:
      return state;
  }
};

export default imsCommonReducer;